export default {
  updateTaskCount(state, params) {
    let obj = {}
    obj[params.namespace] = params.value
    state.taskCount = Object.assign({}, state.taskCount, obj)
  },
  updateTaskSettingsData(state, params) {
    let obj = {}
    obj[params.namespace] = params.value
    state.taskSettingsData = Object.assign({}, state.taskSettingsData, obj)
  },
  updateTaskData(state, params) {
    let obj = {}
    obj[params.namespace] = params.value
    state.taskData = Object.assign({}, state.taskData, obj)
  }
}
